import { Stack, alpha, useTheme } from "@mui/material";
import { InfoCircleIcon } from "../svgIcon/InfoCircle";

const InfoWrapper = ({ children }) => {
  const theme = useTheme();
  return (
    <Stack bgcolor={alpha(theme.palette.info.main, 0.12)} p={2} sx={{ borderRadius: 2 }} direction="row" spacing={1}>
      <InfoCircleIcon color={theme.palette.info.main} />
      {children}
    </Stack>
  );
};

export default InfoWrapper;
